import React from 'react'
import { CAlert, CButton } from '@coreui/react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // Keep this log for operational debugging in production.
    // eslint-disable-next-line no-console
    console.error('UI render error:', error, errorInfo)
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4">
          <CAlert color="danger" className="mb-3">
            Ocorreu um erro inesperado na interface.
          </CAlert>
          <CButton color="primary" onClick={this.handleReload}>
            Recarregar aplicação
          </CButton>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
